module.exports = {
  "airTank": {
    "bindAccount": "绑定账号"
  },
}


// WEBPACK FOOTER //
// ./src/i18n/airTank/en.js